export default {
  updatePlayGameModal(state, payload) {
    state.isPlayGameModalOpen = payload
  },
  updateAcceptTermsModal(state, payload) {
    state.isAcceptTermsModalOpen = payload
  },
  updateLostCodeModal(state, payload) {
    state.isLostCodeModalOpen = payload
  },
  updateMsisdn(state, payload) {
    state.msisdn = payload
    localStorage.setItem('msisdn', state.msisdn)
  },
  updateRedemptionMsisdn(state, payload) {
    state.redemptionMsisdn = payload
    localStorage.setItem('redemptionMsisdn', state.redemptionMsisdn)
  },
  updateSelectedCodeForRedemption(state, payload) {
    state.selectedCodeForRedemption = payload
    localStorage.setItem('currentCode', state.selectedCodeForRedemption)
  },
  updateFoundBonusImage(state, payload) {
    state.foundBonusImage = payload
  },
  updateAvailableSpins(state, payload) {
    state.availableSpins = payload
  },
  updateTopUpValue(state, payload) {
    state.topUpValue = payload
  },
  updatePpsOpenTutorial(state, payload) {
    state.ppsOpenTutorial = payload
  },
  updatePhysicalPrizeModal(state, payload) {
    state.isPhysicalPrizeModalOpen = payload
  },
  updateModalPhysicalPrizeId(state, payload) {
    state.modalPhysicalPrizeId = payload
  },
  updatePrizeDataModal(state, payload) {
    state.isPrizeDataModalOpen = payload
  },
  updatePrizeSmsModal(state, payload) {
    state.isPrizeSmsModalOpen = payload
  },
  updatePrizeEuroModal(state, payload) {
    state.isPrizeEuroModalOpen = payload
  },
  updatePrizeMinutesModal(state, payload) {
    state.isPrizeMinutesModalOpen = payload
  },
  updatePhysicalPrizeResponse(state, payload) {
    state.physicalPrizeResponse = payload
  },
  updateLoginModal(state, payload) {
    state.isLoginModalOpen = payload
  },
  updatePassword(state, payload) {
    state.password = payload
  },
  storeLoginResponse(state, payload) {
    state.loginResponse = payload
  },
  updateAccessToken(state, payload) {
    state.accessToken = payload
    localStorage.setItem('accessToken', state.accessToken)
  },
  updateRegisterModal(state, payload) {
    state.isRegisterModalOpen = payload
  },
  updatePinResponse(state, payload) {
    state.pinResponse = payload
  },
  updateAuthenticatePinResponse(state, payload) {
    state.authenticatePinResponse = payload
  },
  updateHasPasswordResponse(state, payload) {
    state.hasPasswordResponse = payload
  },
  updateCreatePasswordResponse(state, payload) {
    state.createPasswordResponse = payload
  },
  updateForgotPasswordModal(state, payload) {
    state.isForgotPasswordModalOpen = payload
  },
  updateGameFlowState(state, payload) {
    state.gameFlowState = payload
  },
  updateGameResponse(state, payload) {
    state.gameResponse = payload
  },
  updateTelcoInfo(state, payload) {
    state.telcoInfo = payload
  },
  updateHasBeenAwarded(state, payload) {
    state.hasBeenAwarded = payload
  },
  updateExtraChance(state, payload) {
    state.extraChance = payload
  },
  updatePhysicalPrize(state, payload) {
    state.physicalPrize = payload[0]
  },
  updateSelectedTelcoReward(state, payload) {
    state.selectedTelcoReward = payload
  },
  updateDeliveryDetails(state, payload) {
    state.deliveryDetails = payload
  },
  updateOptOutModal(state, payload) {
    state.optOutModalOpen = payload
  },
  updateOptOutResponse(state, payload) {
    state.optOutResponse = payload
  },
  updateOptInResponse(state, payload) {
    state.optInResponse = payload
  },
  storeCheckMarketingConsentResponse(state, payload) {
    state.checkMarketingConsentResponse = payload
  },
  storeUpdateMarketingConsentResponse(state, payload) {
    state.updateMarketingConsentResponse = payload
  },
  storeRegisterMarketingConsentTemp(state, payload) {
    state.registerMarketingConsentTemp = payload
  },
  updateChangePasswordModal(state, payload) {
    state.changePasswordModalOpen = payload
  },
  updatePhysicalDisplayedPrize(state, payload) {
    state.physicalDisplayedPrize = payload
  },
  updateCompareCustomerPasswordResponse(state, payload) {
    state.compareCustomerPasswordResponse = payload
  },
  updateChangePasswordResponse(state, payload) {
    state.compareCustomerPassword = payload
  },
  updateAccountResponse(state, payload) {
    state.accountResponse = payload
  },
  updateSumOfOpenActions(state, payload) {
    state.sumOfOpenActions = payload
  },
  updatePhysicalPrizeWinners(state, payload) {
    state.physicalPrizeWinners = payload
  },
  updateLastMonthWinners(state, payload) {
    state.lastMonthWinners = payload
  },
  updateIsCodeValidForRedeem(state, payload) {
    state.isCodeValidForRedeem = payload
  },
  updateRegisterAsOptIn(state, payload) {
    state.registerAsOptIn = payload
  },
  updateInGameFlow(state, payload) {
    state.inGameFlow = payload
    localStorage.setItem('inGameFlow', state.inGameFlow)
  },
  updateTelcoValidRewardIds(state, payload) {
    state.telcoValidRewardIds = payload
    localStorage.setItem('telcoIds', state.telcoValidRewardIds)
  },
  updateIsPromoBundleCR207(state, payload) {
    state.isPromoBundleCR207 = payload
  },
  updateIsPromoBundleCR208(state, payload) {
    state.isPromoBundleCR208 = payload
  },
  updateIsPromoBundleCR209(state, payload) {
    state.isPromoBundleCR209 = payload
  },
  updateIsPromoBundleIR405(state, payload) {
    state.isPromoBundleIR405 = payload
  },
  updatePlaysCount(state, payload) {
    state.playsCount = payload
  },
  updatePlayChances(state, payload) {
    state.playChances = payload
  },
}



// WEBPACK FOOTER //
// ./src/store/mutations.js